// qiankun/index.js
import { registerMicroApps } from "qiankun";
import { getQiankunConfig } from "./config.js";

// 设置初始需要传递的值
export const getState = () => {
  const state = {
    token: "test-token",
    accessUser: {
      loginName: "test",
    },
  };
  return state;
};

const { subApps } = getQiankunConfig(getState());
// 暴露注册函数，里面对应存放生命周期的钩子，可以做需要的处理
export function registerApps() {
  console.log("register start");
  try {
    registerMicroApps(subApps, {
      beforeLoad: [
        (app) => {
          console.log("before load", app);
        },
      ],
      beforeMount: [
        (app) => {
          console.log("before mount", app);
        },
      ],
      afterUnmount: [
        (app) => {
          console.log("before unmount", app);
        },
      ],
    });
  } catch (err) {
    console.log(err);
  }
}
